import styled from 'styled-components';

import {colors, font, breakpoint} from '../../../theme';

export const Root = styled.form`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;
export const Grid = styled.div<{columns: string; mb?: string}>`
    display: grid;
    grid-template-columns: ${(p) => p.columns};
    grid-auto-rows: auto;
    gap: 10px;
    width: 100%;
    height: 100%;
    margin-bottom: ${(p) => p.mb ?? '0px'};
    @media (max-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr;
    }
`;

export const GridErrorText = styled.span`
    display: flex;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 4px 0;
    justify-content: flex-start;
    align-items: center;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${colors.warnings};
`;

export const Headline = styled.div`
    margin-bottom: 10px;
    padding-left: 2px;
    color: ${colors.black};
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
export const TextLabel = styled.div`
    color: ${colors.textSecondary};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0%;
`;
export const Text = styled.div`
    color: ${colors.black};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0%;

    padding: 0;
    border: 0;
    outline: 0;
    background-color: transparent;
`;
export const TextSub = styled.div`
    color: ${colors.textSecondary};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;

    padding: 0;
    border: 0;
    outline: 0;
    background-color: transparent;
`;
